import { render, staticRenderFns } from "./VAllCases.vue?vue&type=template&id=267b9fd4&"
import script from "./VAllCases.vue?vue&type=script&lang=js&"
export * from "./VAllCases.vue?vue&type=script&lang=js&"
import style0 from "./VAllCases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports